import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class CryptoJsService {
  private _secretKey = environment.secretKey;
  private _llave = environment.llaveSecreta;
  private _claveVectorInicial = environment.claveIv;
  constructor() {}

  encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this._secretKey.trim()).toString();
  }

  decrypt(textToDecrypt: string) {
    try {
      const decryptToken = CryptoJS.AES.decrypt(
        textToDecrypt,
        this._secretKey.trim()
      ).toString(CryptoJS.enc.Utf8);
      return decryptToken;
    } catch (error) {
      return null;
    }
  }

  encryptAES(textoPlano: string) {
    const key = CryptoJS.enc.Utf8.parse(this._llave);
    const iv = CryptoJS.enc.Utf8.parse(this._claveVectorInicial);
    const decrypted = CryptoJS.AES.encrypt(textoPlano, key, { iv });
    return decrypted.toString();
  }

  decryptAES(ciphertextB64: any) {
    const key = CryptoJS.enc.Utf8.parse(this._llave);
    const iv = CryptoJS.enc.Utf8.parse(this._claveVectorInicial);
    const decrypted = CryptoJS.AES.decrypt(ciphertextB64, key, { iv });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
